const languageOptions = [
    { value: 'ar', label: 'Arabic' },
    { value: 'en', label: 'English' },
    // { value: 'bg', label: 'Bulgarian' },
    // { value: 'cs', label: 'Czech' },
    // { value: 'da', label: 'Danish' },
    // { value: 'de', label: 'German' },
    // { value: 'el', label: 'Greek, Modern' },
    // { value: 'es', label: 'Spanish; Castilian' },
    // { value: 'fi', label: 'Finnish' },
    // { value: 'fr', label: 'French' },
    // { value: 'hi', label: 'Hindi' },
    // { value: 'hr', label: 'Croatian' },
    // { value: 'id', label: 'Indonesian' },
    // { value: 'it', label: 'Italian' },
    // { value: 'ja', label: 'Japanese' },
    // { value: 'ko', label: 'Korean' },
    // { value: 'ms', label: 'Malay' },
    // { value: 'nl', label: 'Dutch' },
    // { value: 'pl', label: 'Polish' },
    // { value: 'pt', label: 'Portuguese' },
    // { value: 'ro', label: 'Romanian, Moldavian, Moldovan' },
    // { value: 'ru', label: 'Russian' },
    // { value: 'sk', label: 'Slovak' },
    // { value: 'sv', label: 'Swedish' },
    // { value: 'ta', label: 'Tamil' },
    // { value: 'tl', label: 'Tagalog' },
    // { value: 'tr', label: 'Turkish' },
    // { value: 'uk', label: 'Ukrainian' },
    // { value: 'zh', label: 'Chinese' }
]

const scriptStyleOptions = [
    { value: 'BenefitsV2', label: 'Benefits' },
    { value: 'BrandStoryV2', label: 'Brand Story' },
    { value: 'CallToActionV2', label: 'Call To Action' },
    { value: 'DiscoveryWriter', label: 'Discovery' },
    { value: 'DontWorryWriter', label: "Don't Worry" },
    { value: 'EmotionalWriter', label: 'Emotional' },
    { value: 'GenzWriter', label: 'Gen Z' },
    { value: 'HowToV2', label: 'How To' },
    { value: 'LetMeShowYouWriter', label: 'Let Me Show You' },
    { value: 'MotivationalWriter', label: 'Motivational' },
    { value: 'ProblemSolutionV2', label: 'Problem Solution' },
    { value: 'ProblemSolutionWriter', label: 'Problem-Solution' },
    { value: 'ProductHighlightsV2', label: 'Product Highlights' },
    { value: 'ProductLifestyleV2', label: 'Product Lifestyle' },
    { value: 'ResponseBubbleWriter', label: 'Response Bubble' },
    { value: 'SpecialOffersV2', label: 'Special Offers' },
    { value: 'StoryTimeWriter', label: 'Storytime' },
    { value: 'ThreeReasonsWriter', label: '3 Reasons Why' },
    { value: 'TrendingTopicsV2', label: 'Trending Topics' },
    { value: 'DIY', label: 'DIY' }
]

const visualStyleOptions = [
    { value: 'AvatarBubbleTemplate', label: 'Avatar Bubble (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'DramaticTemplate', label: 'Dramatic (Applicable to aspect_ratio 9x16)' },
    { value: 'DynamicGreenScreenEffect', label: 'Dynamic Green Screen Effect (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'DynamicProductTemplate', label: 'Product (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'DynamicResponseBubbleTemplate', label: 'Response Bubble (Applicable to aspect_ratio 9x16)' },
    { value: 'EnhancedVanillaTemplate', label: 'Dynamic Vanilla (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'FeatureHighlightTemplate', label: 'Feature Highlight (Applicable to aspect_ratio 9x16, 1x1)' },
    { value: 'FullScreenTemplate', label: 'Full Screen (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'FullScreenV2Template', label: 'Full Screen V2 (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'GreenScreenEffectTemplate', label: 'Green Screen Effect (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'LegoTemplate', label: 'Lego (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'MotionCardsTemplate', label: 'Motion Cards (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'OverCardsTemplate', label: 'Over Cards (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'QuickTransitionTemplate', label: 'Quick Transition (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'ScribbleTemplate', label: 'Scribble (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'SideBySideTemplate', label: 'Side by Side (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'SimpleAvatarOverlayTemplate', label: 'Product Presenter (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'TopBottomTemplate', label: 'Top & Bottom (Applicable to aspect_ratio 9x16, 1x1)' },
    { value: 'TwitterFrameTemplate', label: 'Twitter Frame (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'VanillaTemplate', label: 'Vanilla (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'VlogTemplate', label: 'Vlog (Applicable to aspect_ratio 9x16)' },
    { value: 'LegoVisualEmotional', label: 'Emotional (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'LegoVisualCutePets', label: 'Cute Pets (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'LegoVisualAvatarFocusIntro', label: 'Avatar Focus Intro (Applicable to aspect_ratio 9x16, 16x9, 1x1)' },
    { value: 'LegoScriptNegativeHook', label: "Don't Use This If You Want... (Applicable to aspect_ratio 9x16, 1x1, 16x9)" },
    { value: 'LegoScriptNumberOneHook', label: 'The #1 Hack You Need (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptEverWonderHook', label: 'Ever Wonder Why? (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptSecretHook', label: 'Wish I Could Keep This Secret (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptWhatHappensHook', label: 'What Happens If You Try This? (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptAnyoneElseHook', label: 'That One Thing We All Have (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptAmazedHook', label: 'Still Amazed by This (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScript2025Hook', label: 'Hack 2025 Like This (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptHateMeHook', label: "They'll Hate Me for This (Applicable to aspect_ratio 9x16, 1x1, 16x9)" },
    { value: 'LegoScriptResponseBubbleTextOverlay', label: 'Response bubble (Applicable to aspect_ratio 9x16, 1x1)' },
    { value: 'LegoScriptHeyAlgorithmHook', label: 'Hey Algorithm (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptCannotBelieveHook', label: 'Cannot Believe This (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptFinallyConfidentHook', label: 'Finally Confident (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptPremiumFeelingHook', label: 'Premium Feeling (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptFirstTimeFullHook', label: 'First Time Full (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptLongLineReasonHook', label: 'Long Line Reason (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptMissingOutAlertHook', label: 'Missing Out Alert (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptBetterTodayVersionHook', label: 'Better Today Version (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptBigHappeningHook', label: 'Big Happening (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptPriceDropRegretHook', label: 'Price Drop Regret (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptGroupBuyFrustrationHook', label: 'Group Buy Frustration (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptStopAffordExcuseHook', label: 'Stop Afford Excuse (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptLifeTooShortDiscountHook', label: 'Life Too Short Discount (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptHugePriceDropRushHook', label: 'Huge Price Drop Rush (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptPriceCouldGoLowerHook', label: 'Price Could Go Lower (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptStillFullPriceHook', label: 'Still Full Price (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptSecretDiscountShareHook', label: 'Secret Discount Share (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptVoucherSavingsAlertHook', label: 'Voucher Savings Alert (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptCouponDiscoveryRegretHook', label: 'Coupon Discovery Regret (Applicable to aspect_ratio 9x16, 1x1, 16x9)' },
    { value: 'LegoScriptBestDealEverHook', label: 'Best Deal Ever (Applicable to aspect_ratio 9x16, 1x1, 16x9)' }
]

const videoLengthOptions = [
    { value: 15, label: '15 - 15 seconds' },
    { value: 30, label: '30 - 30 seconds' },
    { value: 60, label: '60 - 60 seconds' }
]

const videoAspectRatioOptions = [
    { value: '16x9', label: '16x9' },
    { value: '1x1', label: '1x1' },
    { value: '9x16', label: '9x16' }
]

const targetPlatformOptions = [
    { value: 'tiktok', label: 'TikTok' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'twitter', label: 'Twitter' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'snapchat', label: 'Snapchat' },
    { value: 'pinterest', label: 'Pinterest' },
]

const stepsEnum = {
    stepZero: "stepZero",
    stepOne: "stepOne",
    stepTwo: "stepTwo",
    stepThree: "stepThree",
    stepFour: "stepFour",
    step1: "stepOne",
    step2: "stepTwo",
    step3: "stepThree",
    step4: "stepFour",
  }

const headerStyles = {
    fontWeight: 700,
    fontSize: 18,
}  
export { languageOptions, scriptStyleOptions, visualStyleOptions, videoLengthOptions, videoAspectRatioOptions, targetPlatformOptions, stepsEnum, headerStyles }